// Comprehensive list of banks operating in Indonesia (BUKU I-IV, BPD, digital, syariah, foreign)
// Alphabetically sorted; kept manageable but broad. Update as needed.
export const INDONESIAN_BANKS = [
  "Bank Aceh Syariah",
  "Bank Aladin Syariah",
  "Bank Amar Indonesia",
  "Bank ANZ Indonesia",
  "Bank Artha Graha Internasional",
  "Bank BCA Digital (blu)",
  "Bank BCA Syariah",
  "Bank Bengkulu",
  "Bank BJB (Jabar Banten)",
  "Bank BJB Syariah",
  "Bank BNI",
  "Bank BNP Paribas Indonesia",
  "Bank Bukopin",
  "Bank Bumi Arta",
  "Bank Capital Indonesia",
  "Bank Central Asia (BCA)",
  "Bank China Construction Bank Indonesia",
  "Bank CIMB Niaga",
  "Bank CIMB Niaga Syariah",
  "Bank Citibank Indonesia",
  "Bank Commonwealth",
  "Bank Danamon Indonesia",
  "Bank DBS Indonesia",
  "Bank Deutsche Bank Indonesia",
  "Bank DKI",
  "Bank Ganesha",
  "Bank HSBC Indonesia",
  "Bank IBK Indonesia",
  "Bank ICBC Indonesia",
  "Bank Ina Perdana",
  "Bank Index Selindo",
  "Bank Jago",
  "Bank Jasa Jakarta",
  "Bank Jateng (Jawa Tengah)",
  "Bank Jatim (Jawa Timur)",
  "Bank JTrust Indonesia",
  "Bank Kalbar",
  "Bank Kalsel",
  "Bank Kalteng",
  "Bank Kaltimtara",
  "Bank KEB Hana Indonesia",
  "Bank Lampung",
  "Bank Maluku Malut",
  "Bank Mandiri",
  "Bank Mandiri Taspen",
  "Bank Mantap",
  "Bank Maspion Indonesia",
  "Bank Mayapada",
  "Bank Maybank Indonesia",
  "Bank MayoraDigital",
  "Bank Mega",
  "Bank Mega Syariah",
  "Bank Mestika Dharma",
  "Bank MNC Internasional",
  "Bank Muamalat Indonesia",
  "Bank Multiarta Sentosa",
  "Bank Nagari",
  "Bank Neo Commerce (BNC)",
  "Bank Nobu (Nusantara Parahyangan)",
  "Bank NTB Syariah",
  "Bank NTT",
  "Bank OCBC NISP",
  "Bank Oke Indonesia",
  "Bank Panin",
  "Bank Panin Dubai Syariah",
  "Bank Papua",
  "Bank Permata",
  "Bank Rakyat Indonesia (BRI)",
  "Bank Resona Perdania",
  "Bank Riau Kepri Syariah",
  "Bank Sahabat Sampoerna",
  "Bank Sinarmas",
  "Bank SMBC Indonesia (BTPN)",
  "Bank Standard Chartered Indonesia",
  "Bank Sulselbar",
  "Bank Sulteng",
  "Bank Sultra",
  "Bank Sulutgo",
  "Bank Sumsel Babel",
  "Bank Sumut",
  "Bank Syariah Indonesia (BSI)",
  "Bank Tabungan Negara (BTN)",
  "Bank UOB Indonesia",
  "Bank Victoria International",
  "Bank Woori Saudara",
  "Jenius (BTPN)",
  "LineBank (by Hana Bank)",
  "SeaBank Indonesia",
  "Superbank Indonesia",
  "TMB (Krom Bank)",
  "TMRW by UOB",
];

// Banks used by the company for payroll — no admin fee. Any employee using another bank
// acknowledges the admin transfer fee.
export const COMPANY_BANKS = [
  "Bank Mandiri",
  "Bank BCA",
  "Bank BNI",
  "Bank BRI",
];
